import React from "react";
import {Image} from 'antd';
import {observer} from 'mobx-react';
import {useTranslation} from "react-i18next";
import store from "./store";

import './index.less'

import xingzhuang5512x from './images/xingzhuang551@2x.png'
import xingzhuang5522x from './images/xingzhuang552@2x.png'
import xingzhuang5542x from './images/xingzhuang554@2x.png'
import xingzhuang5552x from './images/xingzhuang555@2x.png'
import xingzhuang5562x from './images/xingzhuang556@2x.png'
import right2x from './images/right.png'

export default observer(function () {
  const {i18n} = useTranslation();// {t('')}
  const {showItemId} = store

  return (
    <div>
      {
        i18n.language === 'zh' ? (
          <div>
            <div className="left">
              <ul>
                <li className={showItemId==='xszn'?'cur guide div':'guide div'} onClick={()=>store.showItemId='xszn'}>
                  <span className="fleft tname">新手指南</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
              </ul>
              <ul>
                <li className='div'>
                  {/* <img src={xingzhuang5522x} className="fleft lpic"/> */}
                  <span className="fleft tname">租赁指南</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='cjwt'?'cur':''} onClick={()=>store.showItemId='cjwt'}>常见问题</li>
                <li className={showItemId==='zllc'?'cur':''} onClick={()=>store.showItemId='zllc'}>租赁流程</li>
                <li className={showItemId==='zjzf'?'cur':''} onClick={()=>store.showItemId='zjzf'}>租金支付</li>
                <li className={showItemId==='kpsm'?'cur':''} onClick={()=>store.showItemId='kpsm'}>开票说明</li>
              </ul>
              <hr className="leftBar"/>
              <ul>
                <li className='div'>
                  {/* <img src={xingzhuang5542x} className="fleft lpic"/> */}
                  <span className="fleft tname">售后服务</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='fwbz'?'cur':''} onClick={()=>store.showItemId='fwbz'}>服务标准</li>
                <li className={showItemId==='pcbz'?'cur':''} onClick={()=>store.showItemId='pcbz'}>赔偿标准</li>
                <li className={showItemId==='thhzc'?'cur':''} onClick={()=>store.showItemId='thhzc'}>退换货政策</li>
              </ul>
              <hr className="leftBar"/>
              <ul>
                <li className='div'>
                  {/* <img src={xingzhuang5552x} className="fleft lpic"/> */}
                  <span className="fleft tname">特殊服务</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='myjzl'?'cur':''} onClick={()=>store.showItemId='myjzl'}>免押金租赁</li>
                <li className={showItemId==='jl'?'cur':''} onClick={()=>store.showItemId='jl'}>计量</li>
              </ul>
              <hr className="leftBar"/>
              <ul>
                <li className='div'>
                  {/* <img src={xingzhuang5562x} className="fleft lpic"/> */}
                  <span className="fleft tname">服务协议</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='zcxy'?'cur':''} onClick={()=>store.showItemId='zcxy'}>注册协议</li>
                <li className={showItemId==='ysbhzc'?'cur':''} onClick={()=>store.showItemId='ysbhzc'}>隐私保护政策</li>
                <li className={showItemId==='qyfwzz'?'cur':''} onClick={()=>store.showItemId='qyfwzz'}>企业服务资质</li>
              </ul>
            </div>
          </div>
        ) : (
          <div className='en'>
            <div className="left">
              <ul>
                <li className='div'>
                  <img src={xingzhuang5522x} className="fleft lpic"/>
                  <span className="fleft tname">Guidance on Leasing</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='cjwt'?'cur':''} onClick={()=>store.showItemId='cjwt'}>FAQ</li>
                <li className={showItemId==='zllc'?'cur':''} onClick={()=>store.showItemId='zllc'}>Rental Procedure</li>
                <li className={showItemId==='zjzf'?'cur':''} onClick={()=>store.showItemId='zjzf'}>Rent Payment</li>
                <li className={showItemId==='kpsm'?'cur':''} onClick={()=>store.showItemId='kpsm'}>Description of Making Invoice</li>
              </ul>
              <hr className="leftBar"/>
              <ul>
                <li className='div'>
                  <img src={xingzhuang5542x} className="fleft lpic"/>
                  <span className="fleft tname">After-sales Service</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='fwbz'?'cur':''} onClick={()=>store.showItemId='fwbz'}>Service Standard</li>
                <li className={showItemId==='pcbz'?'cur':''} onClick={()=>store.showItemId='pcbz'}>Compensation Standards</li>
                <li className={showItemId==='thhzc'?'cur':''} onClick={()=>store.showItemId='thhzc'}>Return & Replacement Policies</li>
              </ul>
              <hr className="leftBar"/>
              <ul>
                <li className='div'>
                  <img src={xingzhuang5552x} className="fleft lpic"/>
                  <span className="fleft tname">Special Services</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='myjzl'?'cur':''} onClick={()=>store.showItemId='myjzl'}>Deposit-free Lease</li>
                <li className={showItemId==='jl'?'cur':''} onClick={()=>store.showItemId='jl'}>Measurement</li>
              </ul>
              <hr className="leftBar"/>
              <ul>
                <li className='div'>
                  <img src={xingzhuang5562x} className="fleft lpic"/>
                  <span className="fleft tname">Service Agreement</span>
                  <img src={right2x} className="fleft ricon"/>
                </li>
                <li className={showItemId==='zcxy'?'cur':''} onClick={()=>store.showItemId='zcxy'}>Registration Agreement</li>
                <li className={showItemId==='qyfwzz'?'cur':''} onClick={()=>store.showItemId='qyfwzz'}>Corporate Service Qualification</li>
              </ul>
            </div>
          </div>
        )
      }
    </div>
  )
})
